import { render, staticRenderFns } from "./SearchPill.vue?vue&type=template&id=0a7f4b59&scoped=true&"
import script from "./SearchPill.vue?vue&type=script&lang=js&"
export * from "./SearchPill.vue?vue&type=script&lang=js&"
import style0 from "./SearchPill.vue?vue&type=style&index=0&id=0a7f4b59&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7f4b59",
  null
  
)

export default component.exports